module.exports = __webpack_public_path__ + "static/media/project.27eab995.png";